import { render } from "./NotaFiscalModal.vue?vue&type=template&id=528fc601&scoped=true&ts=true"
import script from "./NotaFiscalModal.vue?vue&type=script&lang=ts"
export * from "./NotaFiscalModal.vue?vue&type=script&lang=ts"

import "./NotaFiscalModal.vue?vue&type=style&index=0&id=528fc601&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528fc601"]])

export default __exports__